module.exports = __webpack_public_path__ + "img/undraw_welcoming.739c7146.svg";